export default {
    name: 'QIcon',
    props: {
        icon: {
            type: String,
            required: true
        },
        width: {
            type: Number,
            required: false
        },
        height: {
            type: Number,
            required: false
        },
        size: {
            type: String, // sm, lg, defaults to a medium size between sm and lg.
            default: ''
        },
        color: {
            type: String, // primary, info, success, warning, danger etc...
            default: ''
        },
        inline: {
            type: Boolean,
            default: false
        },
        customClass: {
            type: String,
            default: ''
        }
    },
    computed: {
        iconColor() {
            if (this.color) {
                return `text-${this.color}`;
            }
        }
    }
};
